import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { docCompareEndpoint } from '~/api/def/endpoints/docCompare/docCompareEndpoint';
import { DocCompareChunkFinderChunk } from '~/api/def/endpoints/docCompare/docCompareChunkFinderEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';

const endpointDocCompareWholeDocumentPostExec =
  getExecEndpoint<DocCompareWholeDocumentEndpointDef>(docCompareEndpoint);
export const docCompareWholeDocumentEndpointPOST = async (
  payload: DocCompareWholeDocumentParams,
) => {
  const formData = new FormData();
  formData.append(
    'chat_request',
    JSON.stringify({
      chunks: payload.chunks,
      chat_history: payload?.history ? payload.history : [],
    }),
  );
  if (payload.input_file) {
    formData.append('input_file', payload.input_file);
  }
  return endpointDocCompareWholeDocumentPostExec<'POST'>({
    method: 'POST',
    urlExtra: `/whole-document?question=${payload.question}`,
    payload: formData,
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });
};

export type DocCompareWholeDocumentParams = {
  question: string;
  chunks: DocCompareChunkFinderChunk[];
  history?: ChatHistory[];
  input_file?: File;
};
export interface DocCompareWholeDocumentEndpointDef {
  endpoint: typeof docCompareEndpoint;
  methods: {
    POST: {
      response: DocCompareWholeDocumentResponse;
      payload: DocCompareWholeDocumentRequest;
    };
  };
}
export type DocCompareWholeDocumentResponse = BqResponse<{ data: string }>;

export type DocCompareWholeDocumentRequest = FormData;

export interface ChatHistory {
  role: string;
  content: Content[];
}

export interface Content {
  text: string;
}
